import { CIcon } from '~/icons/types'

export const ciCars: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.558 10.623c-1.172-.459-2.747-.726-4.678-.806-.272-.201-.53-.403-.783-.6C14.634 8.073 13.257 7 9.933 7c-3.666 0-5.016.933-6.577 2.02-.23.16-.464.32-.708.483l-1.18.352c-.615.182-1.07.782-1.126 1.5-.014.168-.014.347-.019.534 0 .094 0 .188-.004.281-.235.282-.305.69-.319.933v1.05c0 .938.553 1.566 1.373 1.566h1.088a2.774 2.774 0 0 1-.042-.488c0-1.547 1.275-2.808 2.845-2.808 1.57 0 2.845 1.257 2.845 2.808 0 .164-.014.328-.042.488h7.683a2.777 2.777 0 0 1-.042-.488c0-1.547 1.275-2.808 2.845-2.808 1.57 0 2.845 1.257 2.845 2.808 0 .164-.014.328-.042.483.305-.01.746-.037 1.167-.112.366-.066.647-.15.868-.258.51-.253.586-.619.586-.811v-1.078c0-.863-.418-2.058-2.42-2.832ZM7.33 10.098c-.46 0-.914-.206-1.275-.58l-.581-.596c.947-.586 2.105-.985 4.013-1.036l.3 2.217H7.33v-.005Zm3.455-.004-.3-2.213c2.442.122 3.539 1.04 4.79 2.213h-4.49Z'
    },
    {
      d:
        'M18.553 13.04c-1.186 0-2.151 1.002-2.151 2.188a2.147 2.147 0 1 0 4.294 0c0-1.186-.962-2.189-2.143-2.189Zm-13.298-.013c-1.186 0-2.157 1.008-2.157 2.194s.966 2.152 2.152 2.152a2.152 2.152 0 0 0 2.152-2.152c0-1.19-.961-2.194-2.147-2.194Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'cars',
  type: 'solid'
}
